import { useApp } from '../../../../../context/App';
import { INews } from '../../../../../types/news';
import { parseDate } from "../../../../../utils/date";

interface Props {
	news: INews;
	isHero?: boolean;
}

export function CardMobileNews({ news, isHero = false }: Props) {
	const { configDomainURL } = useApp()
	const domain = configDomainURL
	const link_montado = news.title
		.toLowerCase()
		.replaceAll(' ', '-')
		.replaceAll('/', '-')
		.replaceAll(new RegExp('[&/\\\\#,+()$~%.\'":*?<>{}]', 'g'), '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, "")

	const CardMobileNews_img = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/foto/' + news.img

	if (isHero) {
		return (
			<a
				href={`${domain}noticias/${news.newsId}/${link_montado}`}
				className="relative w-full h-64 rounded-2xl overflow-hidden shadow-lg group no-underline block"
			>
				{!!news.img && (
					<img
						src={CardMobileNews_img}
						className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
						alt={news.title}
						loading="lazy"
					/>
				)}
				<div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent flex flex-col justify-end p-5">
					<span className="text-secondary text-[10px] font-bold uppercase tracking-widest mb-2 px-2 py-1 bg-black/30 backdrop-blur-md rounded-lg w-fit">
						{parseDate(news.published)}
					</span>
					<h4 className="text-white font-bold text-lg leading-tight line-clamp-3 group-hover:text-secondary-light transition-colors">
						{news.title}
					</h4>
				</div>
			</a>
		)
	}

	return (
		<a
			href={`${domain}noticias/${news.newsId}/${link_montado}`}
			className="w-full flex flex-col no-underline group"
		>
			{!!news.img && (
				<img
					src={CardMobileNews_img}
					className="w-full h-36 rounded-xl object-cover mb-3 dark:opacity-90 shadow-sm transition-all duration-300 group-hover:shadow-md"
					alt={news.title}
					loading="lazy"
				/>
			)}

			<div className="w-full flex flex-col gap-1.5 px-1">
				<h4 className="font-roboto text-on-surface dark:text-on-surface-dark font-bold text-[0.8125rem] leading-snug line-clamp-3 group-hover:text-primary dark:group-hover:text-secondary transition-colors">
					{news.title}
				</h4>
				<span className="font-roboto text-on-surface-subtle dark:text-on-surface-dark-muted font-normal text-[0.6875rem] uppercase tracking-wider opacity-70">
					{parseDate(news.published)}
				</span>
			</div>
		</a>
	)
}